import MetaData from "@/components/seo/MetaData";
import React from "react";

function TermsOfUse() {
  const pageUrl = `${process.env.NEXT_PUBLIC_SITE_ABSOLUTE_URL}/terms-of-use`;

  return (
    <>
      <MetaData url={pageUrl} />
      <div className="px-[2rem] lg:px-[7.5rem] pt-[4rem] pb-[7.5rem]">
        <h1 className="text-[ #0A101A] font-semibold text-[2.625rem]">
          AmarPet Terms of Use
        </h1>

        <div className="space-y-[1.5rem] mt-[2rem]">
          <p className="text-[#1F2A3B] font-bold">Introduction</p>

          <p>
            Welcome to AmarPet.com. This is a subsidiary of Appnap Technologies
            Limited that provides access to the website, information, tools, and
            services set out below. A user agrees to be bound by the terms and
            conditions while accessing the website. Thus, it is highly
            recommended to go through the Terms and Conditions carefully, as the
            usage of our website signifies user agreement.
          </p>

          <p>
            For the sake of transparency, it is implied without limitation that
            the terms &ldquo;user,&ldquo; &ldquo;customer,&ldquo; and
            &ldquo;you&ldquo; in any context refer to any natural or legally
            eligible person who accesses the website as an end user. References
            to &ldquo;AmarPet,&ldquo; &ldquo;Company,&ldquo;
            &ldquo;Website,&ldquo; &ldquo;we,&ldquo; &ldquo;us,&ldquo; and
            &ldquo;our&ldquo; correspond to AmarPet&quot;s website and any
            licenses owned by Appnap Technologies Limited.
          </p>

          <p>
            You may terminate your agreement with AmarPet by not visiting our
            website and deleting your account.
          </p>
        </div>

        <div className="space-y-[1.5rem] mt-[2rem]">
          <p className="text-[#1F2A3B] font-bold">Changes to Terms</p>

          <p>
            Any updates to the tools, features, and services added to the Terms
            & Conditions will be effective immediately and added to this page.
            AmarPet retains the right to amend or replace any portion of the
            Terms & Conditions through updates and/or modifications to the
            website. It is advised to view this page regularly to be concurrent
            to the Terms. Following the publication of such modifications, your
            continued use of our service indicates your acknowledgement of the
            updates.
          </p>
        </div>

        <div className="space-y-[1.5rem] mt-[2rem]">
          <p className="text-[#1F2A3B] font-bold">Payment Terms</p>

          <p>
            We accept payments through the cash-on-delivery method. We also
            accept Visa, Mastercard, and American Express, as well as mobile
            banking services such as bKash and Nagad. By making a payment, you
            give authorization to the store to charge your card or financial
            account for the total amount of your order, which will include any
            applicable delivery charges. AmarPet uses secure payment gateways to
            ensure the security of customers&quot; financial information. The
            payment process will be initiated upon receipt of an order, and all
            transactions are conducted in BDT and are inclusive of VAT. An order
            confirmation email will be sent to the user&quot;s email address
            once an order is accepted. In case of any payment dispute, we will
            work with the customer to resolve it in a timely and satisfactory
            manner.
          </p>
        </div>

        <div className="space-y-[1.5rem] mt-[2rem]">
          <p className="text-[#1F2A3B] font-bold">Delivery Terms</p>

          <p>
            AmarPet provides home delivery services throughout Bangladesh. We
            offer standard shipping options, and delivery time and charges will
            depend on the weight of the order and the customer&quot;s location.
            Under the ideal situation, home delivery inside the Dhaka
            metropolitan area will be processed within 24 hours of placing an
            order, and outside Dhaka, 72 hours will be required. However,
            delivery completion might take longer than the usual timeframe under
            unavoidable circumstances and any undue events. AmarPet holds the
            right to make adjustments to this time frame.
          </p>

          <p>
            For orders confirmed outside the Dhaka metropolitan area, AmarPet
            requires that the delivery charge be paid in advance. This helps to
            ensure the timely and secure delivery of your order. The product
            cost, however, can be paid through a cash-on-delivery method,
            allowing you to pay when the product is delivered to you. By
            offering both advance payment options and cash on delivery, we aim
            to provide a flexible payment process that meets the needs of all
            our customers.
          </p>

          <p>
            AmarPet might use third-party services to handle the shipping
            process. The store is not responsible for any undue delays caused by
            shipping carriers or unforeseen circumstances.
          </p>

          <p>
            The customer is responsible for providing a correct and complete
            delivery address. The store is not responsible for deliveries to
            incorrect or incomplete addresses provided by the customer. If a
            customer receives a damaged item or their order is lost in transit,
            the store will work with the customer to resolve the issue and
            provide a replacement or refund as appropriate.
          </p>
        </div>

        <div className="space-y-[1.5rem] mt-[2rem]">
          <p className="text-[#1F2A3B] font-bold">
            Cancellation or Modification of Order
          </p>

          <p>
            For any reason, including but not limited to the product being
            mispriced, out of stock, expired, damaged, malfunctioning, and/or
            containing erroneous information or a description due to a technical
            or typographical error, AmarPet has the absolute right to cancel any
            order prior to shipping. An order placed by the seller can only be
            cancelled at AmarPet&quot;s discretion. Once an order has been
            dispatched to the delivery address, AmartPet will no longer accept
            any cancellation or modification without assessing the delivery cost
            and the loss incurred due to the cancellation of the order.
          </p>

          <p>
            Once you have placed an order with us, a representative from AmarPet
            will reach out to you for confirmation. This is an important step in
            ensuring that you receive the correct product and that all the
            details of your order are accurate. If, for any reason, you wish to
            cancel your order, it is important to do so during the confirmation
            call. Once the order has been confirmed, no cancellations will be
            accepted. If the delivery personnel have already reached your
            location and you wish to cancel the order, you will be required to
            pay the full delivery charge for it.
          </p>

          <p>
            While AmarPet will try to comply with the customer&quot;s request to
            amend their purchase, not all requests can be guaranteed to be met.
            However, modification of the order will only be possible until the
            order has not been dispatched. The consumer is in charge of making
            sure that all facts included with their order, including the
            delivery address, payment information, and product specifics, are
            accurate. They should contact us if any such information provided by
            them is incorrect.
          </p>
        </div>

        <div className="space-y-[1.5rem] mt-[2rem]">
          <p className="text-[#1F2A3B] font-bold">
            Indemnification and Limitation of Liability
          </p>

          <p>
            In no event shall the company or its stakeholders be liable for any
            direct, indirect, incidental, consequential, special, or punitive
            damages, including but not limited to loss of profits, revenue,
            goodwill, data, personal injury, personal damage, or intangible loss
            arising out of or in connection with any transaction with AmarPet.
          </p>

          <p>
            You agree to indemnify and hold harmless the company, its parent,
            subsidiaries, personnel, affiliates, internal service providers, and
            their respective officers, shareholders, directors, agents, and
            employees from any claim or demand against any losses, liabilities,
            actions, suits, claims, proceedings, costs, damages, decisions,
            settlement fees, or penalties incurred by any third party.{" "}
          </p>

          <p>
            The cost of the purchased item represents the extent of the
            store&quot;s financial responsibility. Any accidental,
            extraordinary, exemplary, or consequential losses are not the
            responsibility of AmarPet. While AmarPet makes a fair effort to
            guarantee that product details, pricing, and availability are
            accurate, mistakes can nevertheless happen. Any damage or injury
            brought on by using items purchased from the store&quot;s website is
            not the store&quot;s fault. Customers must read all warnings and
            product information before using the product. Any losses or damages
            that can happen during delivery are not covered by the store&quot;s
            insurance. The customer should inspect their order upon receipt and
            report any damages to the store immediately.
          </p>
        </div>

        <div className="space-y-[1.5rem] mt-[2rem]">
          <p className="text-[#1F2A3B] font-bold">Governing Law</p>

          <p>
            The applicable laws regulating e-commerce in Bangladesh will govern
            our terms and conditions, and our services will be implemented in
            line with the agreements. Any enforceable legitimate claim or
            procedure emerging in association with AmarPet must be dealt with
            under the jurisdiction of a Bangladeshi court.
          </p>
        </div>
      </div>
    </>
  );
}

export default TermsOfUse;
